import React, { useState, useEffect } from "react";
import { ArrowLeft, ArrowRight, CheckCircle2 } from "lucide-react";
import {
  getReview,
  saveEvaluation,
  verifyApplication,
  submitEvaluation,
} from "../api/applicationReviewService";
import { Badge } from "../components/common";
import QuestionCard from "./QuestionCard";
import ReviewerReviews from "./ReviewerReviews";
export default function ApplicationDetail({ applicationId, onBack, onAdjacent }) {
  console.log("ApplicationDetail rendered");
  console.log(applicationId);

  const [app, setApp] = useState(null);

  const [loading, setLoading] = useState(true);

  const [collapsed, setCollapsed] = useState(false);
  const [saving, setSaving] = useState(false);

  const currentUserId = localStorage.getItem("userId");
  const rawRole = localStorage.getItem("role");

  const isSuperAdmin =
    rawRole?.trim().toLowerCase() === "superadmin";

  const isAdmin =
    rawRole?.trim().toLowerCase() === "admin";

  useEffect(() => {
    loadApplication();
  }, [applicationId]);



  const loadApplication = async () => {
    try {
      setLoading(true);

      const currentUserId = localStorage.getItem("userId");

      if (!currentUserId) {
        throw new Error("Logged-in user ID not found.");
      }

      const data = await getReview(
        applicationId,
        currentUserId
      );

      console.log(
        "========== RAW REVIEW API =========="
      );

      console.log(data);

      data.sections?.forEach(section => {

        console.log(
          `SECTION ${section.sectionNo}`,
          Object.keys(section)
        );

        console.log(
          "FILES:",
          section.files
        );

        console.log(
          "DOCUMENTS:",
          section.documents
        );

        console.log(
          "ATTACHMENTS:",
          section.attachments
        );

        console.log(
          "UPLOADED FILES:",
          section.uploadedFiles
        );

        console.log(
          "ITEMS:",
          section.items
        );
      });


      const normalizedData = {
        ...data,

        questions: (
          data.questions ??
          data.sections ??
          []
        ).map(section => {

          // -----------------------------------------
          // FILES
          // Backend review API returns:
          // section.files
          // -----------------------------------------
          const files = Array.isArray(section.files)
            ? section.files.map(file => ({
              ...file,

              fileId:
                file.fileId ??
                file.id,

              fileName:
                file.fileName ??
                file.storedFileName ??
                "Document",

              filePath:
                file.filePath ??
                ""
            }))
            : [];

          const uniqueFiles = files.filter(
            (file, index, arr) =>
              index ===
              arr.findIndex(
                f =>
                  String(f.fileId) ===
                  String(file.fileId)
              )
          );

          const reviewerReviews = Array.isArray(section.reviewerReviews)
            ? section.reviewerReviews.map(review => ({
              reviewerId: review.reviewerId,

              reviewerName:
                review.reviewerName ??
                "Unknown Reviewer",

              reviewedMarks:
                Number(review.reviewedMarks ?? 0),

              isVerified:
                review.isVerified ?? false,

              remark:
                review.remark ?? "",

              reviewedOn:
                review.reviewedOn ?? null,

              isFinal:
                review.isFinal ?? false
            }))
            : [];

          // -----------------------------------------
          // OPTIONS / ITEMS
          // -----------------------------------------
          const items = Array.isArray(section.items)
            ? section.items
            : [];

          const options = (
            section.options ??
            section.items ??
            []
          ).map(item => ({
            ...item,

            optionId:
              item.optionId ??
              item.itemId ??
              item.id,

            reviewedMarks: Number(
              item.reviewedMarks ??
              item.reviewedMark ??
              item.reviewedMarksObtained ??
              0
            ),

            maxMarks:
              Number(item.maxMarks ?? 5),

            // Teacher's selected answer
            selectedOptionId:
              item.selectedOptionId ??
              item.selectedOptionID ??
              item.selectedId ??
              null,

            selectedOption:
              item.selectedOption ??
              item.selectedAnswer ??
              item.answer ??
              item.optionText ??
              "",

            year:
              item.year ??
              item.financialYear ??
              item.academicYear ??
              null,

            files: item.files ?? []
          }));

          // -----------------------------------------
          // REVIEWED MARKS
          // -----------------------------------------
          const optionTotal = options.reduce(
            (sum, option) =>
              sum + Number(option.reviewedMarks ?? 0),
            0
          );

          const reviewedMarks =
            Number(section.sectionNo) === 24
              ? Math.min(
                Number(section.maxMarks ?? 5),
                optionTotal
              )
              : Number(
                section.reviewedMarks ??
                section.marks ??
                section.obtainedMarks ??
                0
              );

          return {
            ...section,

            sectionId:
              section.sectionId ??
              section.sectionNo,

            // IMPORTANT:
            // Don't lose teacher marks.
            marks: Number(
              section.marks ??
              section.teacherMarks ??
              section.obtainedMarks ??
              section.totalMarks ??
              0
            ),

            teacherMarks: Number(
              section.teacherMarks ??
              section.marks ??
              section.obtainedMarks ??
              0
            ),

            reviewedMarks:
              section.sectionNo === 24
                ? Math.min(
                  Number(section.maxMarks ?? 5),
                  options.reduce(
                    (sum, option) =>
                      sum + Number(option.reviewedMarks ?? 0),
                    0
                  )
                )
                : Number(
                  section.reviewedMarks ??
                  section.reviewedMarksObtained ??
                  section.reviewedMark ??
                  0
                ),

            maxMarks: Number(
              section.maxMarks ?? 0
            ),

            isVerified:
              section.isVerified ??
              section.isCompleted ??
              false,

            remark:
              section.remark ??
              "",

            options,

            files: uniqueFiles,
            reviewerReviews
          };
        }),

        // -----------------------------------------
        // TEACHER INFORMATION
        // -----------------------------------------
        name:
          data.teacher?.name ??
          data.name ??
          "",

        teacherName:
          data.teacher?.name ??
          data.teacherName ??
          "",

        mobile:
          data.teacher?.mobile ??
          data.mobile ??
          "",

        school:
          data.teacher?.schoolName ??
          data.school ??
          "",

        district:
          data.teacher?.district ??
          data.district ??
          "",

        taluka:
          data.teacher?.taluka ??
          data.taluka ??
          "",

        cluster:
          data.cluster ??
          data.teacher?.cluster ??
          "",
        // -----------------------------------------
        // TOTAL
        // -----------------------------------------
        reviewedTotalMarks: Number(
          data.reviewedTotalMarks ?? 0
        )
      };

      setApp(normalizedData);
      console.log("NORMALIZED QUESTIONS:", normalizedData.questions);
      normalizedData.questions.forEach(q => {
        console.log(
          `SECTION ${q.sectionNo}`,
          {
            files: q.files,
            fileCount: q.files?.length,
            items: q.items,
            options: q.options
          }
        );
      });

      setApp(normalizedData);
      console.log("Loaded application:", normalizedData);
    }
    catch (err) {
      console.error("Failed to load application:", err);
    }
    finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-8 text-center">
        Loading...
      </div>
    );
  }

  if (!app) {
    return (
      <div className="p-8 text-center">
        Application not found.
      </div>
    );
  }


  const saveDraft = async () => {
    try {
      setSaving(true);

      const currentUserId = localStorage.getItem("userId");

      const dto = {
        sections: app.questions.map(q => {

          const isSection24 =
            Number(q.sectionNo) === 24;

          const optionTotal =
            (q.options ?? []).reduce(
              (sum, option) =>
                sum +
                Number(option.reviewedMarks ?? 0),
              0
            );

          const sectionMarks =
            isSection24
              ? Math.min(
                Number(q.maxMarks ?? 5),
                optionTotal
              )
              : Number(q.reviewedMarks ?? 0);

          return {
            sectionId: q.sectionId,

            // Section 24 => maximum 5
            marks: sectionMarks,

            isCompleted: q.isVerified,

            remark: q.remark,

            currentUserId:
              localStorage.getItem("userId"),

            options: (q.options ?? []).map(
              option => ({
                optionId: option.optionId,
                marks: Number(
                  option.reviewedMarks ?? 0
                )
              })
            )
          };
        })
      };

      console.log("SAVE DTO:", dto);

      await saveEvaluation(app.applicationId, dto);

      await loadApplication();

      alert("Saved");
    }
    catch (err) {
      console.error("Save failed:", err);
      console.error("Response:", err?.response?.data);

      alert(
        err?.response?.data?.message ||
        "Failed to save evaluation."
      );
    }
    finally {
      setSaving(false);
    }
  };

  const total = app.questions.reduce(
    (sum, q) => sum + Number(q.reviewedMarks ?? 0),
    0
  );
  const completed = app.questions.filter(q => q.isVerified).length;
  const pct = app.questions.length ? Math.round((completed / app.questions.length) * 100) : 0;

  const visible = app.questions;

  function setMarks(sectionId, value) {
    setApp(prev => ({
      ...prev,
      questions: prev.questions.map(q =>
        q.sectionId === sectionId
          ? {
            ...q,
            reviewedMarks: Math.max(
              0,
              Math.min(q.maxMarks, Number(value))
            )
          }
          : q
      )
    }));
  }

  function setVerify(sectionId, state) {
    setApp(prev => ({
      ...prev,
      questions: prev.questions.map(q =>
        q.sectionId === sectionId
          ? {
            ...q,
            isVerified: state
          }
          : q
      )
    }));
  }

  function setRemark(sectionId, value) {
    setApp(prev => ({
      ...prev,
      questions: prev.questions.map(q =>
        q.sectionId === sectionId
          ? {
            ...q,
            remark: value
          }
          : q
      )
    }));
  }

  const submit = async () => {
    try {
      setSaving(true);

      const currentUserId = localStorage.getItem("userId");

      const dto = {
        sections: app.questions.map(q => {

          const optionTotal = (
            q.options ?? []
          ).reduce(
            (sum, option) =>
              sum + Number(option.reviewedMarks ?? 0),
            0
          );

          const sectionMarks =
            q.sectionNo === 24
              ? Math.min(
                Number(q.maxMarks ?? 5),
                optionTotal
              )
              : Number(q.reviewedMarks ?? 0);

          return {
            sectionId: q.sectionId,

            marks: sectionMarks,

            isCompleted: q.isVerified,

            remark: q.remark,

            currentUserId:
              localStorage.getItem("userId"),

            options: (q.options ?? [])
              .filter(option => option.optionId != null)
              .map(option => ({
                optionId: option.optionId,
                marks: Number(
                  option.reviewedMarks ?? 0
                )
              }))
          };
        })
      };

      console.log("SUBMIT DTO:", dto);

      await saveEvaluation(app.applicationId, dto);

      await loadApplication();

      alert("Evaluation submitted.");
    }
    catch (err) {
      console.error("Submit failed:", err);

      alert(
        err?.response?.data?.message ||
        "Failed to submit evaluation."
      );
    }
    finally {
      setSaving(false);
    }
  };


  const onOptionMarks = (
    sectionId,
    optionId,
    index,
    marks
  ) => {
    setApp(prev => ({
      ...prev,

      questions: prev.questions.map(section => {

        if (section.sectionId !== sectionId) {
          return section;
        }

        let options = [...(section.options ?? [])];

        const numericMarks = Math.min(
          5,
          Math.max(
            0,
            Number(marks) || 0
          )
        );

        // Existing backend option
        if (optionId !== null && optionId !== undefined) {

          options = options.map(option =>
            String(option.optionId) === String(optionId)
              ? {
                ...option,
                reviewedMarks: numericMarks
              }
              : option
          );

        } else {

          /*
           * This is one of our display-only
           * Section 24 rows.
           *
           * We create a local option object.
           */
          options[index] = {
            ...(options[index] ?? {}),

            optionId: null,

            reviewedMarks: numericMarks,

            maxMarks: 5,

            isEmpty: true,

            displayOrder: index + 1
          };
        }

        const optionTotal = options.reduce(
          (sum, option) =>
            sum +
            Number(option.reviewedMarks ?? 0),
          0
        );

        const reviewedMarks =
          Number(section.sectionNo) === 24
            ? Math.min(
              Number(section.maxMarks ?? 5),
              optionTotal
            )
            : Number(section.reviewedMarks ?? 0);

        return {
          ...section,
          options,
          reviewedMarks
        };
      })
    }));
  };

  const evCounts = {
    image: 0,
    pdf: 0,
    certificate: 0,
    link: 0
  };

  app.questions.forEach(q => {
    (q.files ?? []).forEach(file => {
      const ext = file.fileName?.split(".").pop()?.toLowerCase();

      if (["jpg", "jpeg", "png"].includes(ext)) {
        evCounts.image++;
      } else if (ext === "pdf") {
        evCounts.pdf++;
      }
    });
  });

  return (
    <div className="p-3 sm:p-5 lg:p-7 bg-slate-50 min-h-screen">
      <button
        onClick={onBack}
        className="mb-4 text-xs font-semibold border border-slate-300 bg-white px-3.5 py-2 rounded-lg flex items-center gap-1.5 hover:border-blue-600 hover:text-blue-600"
      >
        <ArrowLeft size={13} /> अर्ज यादीकडे परत
      </button>

      <div
        className={`bg-white border border-slate-200 rounded-2xl shadow-sm flex justify-between gap-4 sm:gap-6 flex-wrap lg:top-3 z-20 mb-4 transition-all ${collapsed ? "p-3.5 items-center" : "p-4 sm:p-6"}`}
      >
        <div>
          <h2
            className={`font-bold flex flex-wrap items-center gap-2 ${collapsed ? "text-sm mb-0" : "text-base sm:text-lg mb-2.5"}`}
          >
            {app.name} <Badge status={app.status} />
          </h2>
          {!collapsed && (
            <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-x-5 sm:gap-x-8 gap-y-3">
              {[
                ["Teacher", app.teacherName],
                ["मोबाईल नंबर", app.mobile],
                ["शाळेचे नाव", app.school],
                ["जिल्हा", app.district],
                ["तालुका", app.taluka],
                ["केंद्र (Cluster)", app.cluster],
                ["Application ID", app.applicationNumber],
                ["पदनाम", app.questions[0]?.title],
              ].map(([k, v]) => (
                <div key={k} className="text-xs">
                  <span className="block text-slate-400 mb-0.5">{k}</span>
                  <b className="text-sm font-semibold">{v}</b>
                </div>
              ))}
            </div>
          )}
        </div>
        {!collapsed && (
          <div className="flex flex-col items-end gap-2 w-full sm:w-auto sm:min-w-[220px]">
            <div className="grid grid-cols-3 gap-3 sm:gap-5 items-center w-full">
              <div className="text-right">
                <b className="block text-lg font-bold text-blue-600">
                  {completed}/{app.questions.length}
                </b>
                <span className="text-[10px] text-slate-400">प्रश्न पूर्ण</span>
              </div>
              <div className="text-right">
                <b className="block text-lg font-bold text-blue-600">
                  {app.questions.reduce(
                    (sum, q) => sum + Number(q.maxMarks ?? 0),
                    0
                  )}
                </b>
                <span className="text-[10px] text-slate-400">
                  कमाल गुण
                </span>
              </div>
              <div className="text-right">
                <b className="block text-lg font-bold text-blue-600">{total}</b>
                <span className="text-[10px] text-slate-400">प्राप्त गुण</span>
              </div>
            </div>
            <div className="w-full sm:w-56 h-2 bg-slate-100 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${pct}%`,
                  background: "linear-gradient(90deg,#2563eb,#60a5fa)",
                }}
              />
            </div>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_300px] gap-5 items-start">
        <div className="flex flex-col gap-3.5">
          {visible.map((q) => (
            <React.Fragment key={q.sectionId}>

              <QuestionCard
                q={q}
                onMarks={setMarks}
                onOptionMarks={onOptionMarks}
                onVerify={setVerify}
                onRemark={setRemark}
                isSuperAdmin={isSuperAdmin}
              />


            </React.Fragment>
          ))}
          {visible.length === 0 && (
            <div className="text-center text-slate-400 text-sm py-10 bg-white border border-slate-200 rounded-xl">
              जुळणारे प्रश्न सापडले नाहीत
            </div>
          )}
        </div>

        <aside className=" lg:top-24 bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
          <h3 className="text-sm font-bold mb-4">Submission Summary</h3>
          <div className="flex justify-center mb-4">
            <div
              className="w-28 h-28 rounded-full flex items-center justify-center"
              style={{
                background: `conic-gradient(#2563eb ${pct}%, #eef1f5 0)`,
              }}
            >
              <div className="w-[88px] h-[88px] rounded-full bg-white flex flex-col items-center justify-center">
                <b className="text-lg font-bold text-blue-600">{pct}%</b>
                <span className="text-[9px] text-slate-400">पडताळणी झाली</span>
              </div>
            </div>
          </div>
          {[
            ["एकूण प्रश्न", app.questions.length],
            ["अपलोड इमेजेस", evCounts.image],
            ["अपलोड PDF", evCounts.pdf],
            ["अपलोड प्रमाणपत्रे", evCounts.certificate],
            ["अपलोड लिंक्स", evCounts.link],
          ].map(([k, v]) => (
            <div
              key={k}
              className="flex justify-between text-xs py-2 border-b border-dashed border-slate-200"
            >
              <span>{k}</span>
              <b className="font-bold">{v}</b>
            </div>
          ))}
          <div className="mt-3 bg-blue-50 rounded-lg px-3.5 py-3 flex justify-between font-bold text-sm text-blue-700">
            <span>एकूण गुण</span>
            <span>
              {total}
            </span>
          </div>
        </aside>
      </div>

      <div className="sticky bottom-0 z-30 mt-6 -mx-3 sm:-mx-5 lg:-mx-7 px-3 sm:px-5 lg:px-7 py-3.5 bg-white/95 backdrop-blur border-t border-slate-200 flex flex-col xl:flex-row justify-between items-stretch xl:items-center gap-2.5">
        <div className="grid grid-cols-2 gap-2.5">
          <button
            onClick={() => onAdjacent(-1)}
            className="w-full justify-center text-xs font-bold border border-slate-200 bg-white px-3 sm:px-4 py-2.5 rounded-lg flex items-center gap-1.5"
          >
            <ArrowLeft size={13} /> मागील शिक्षक
          </button>
          <button
            onClick={() => onAdjacent(1)}
            className="w-full justify-center text-xs font-bold border border-slate-200 bg-white px-3 sm:px-4 py-2.5 rounded-lg flex items-center gap-1.5"
          >
            पुढील शिक्षक <ArrowRight size={13} />
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
          <button
            onClick={saveDraft}
            disabled={saving}
            className={`w-full text-xs font-bold px-3 sm:px-4 py-2.5 rounded-lg border ${saving
              ? "bg-slate-100 text-slate-400 border-slate-200 cursor-not-allowed"
              : "bg-white border-slate-200"
              }`}
          >
            {saving ? "Saving..." : "मसुदा जतन करा"}
          </button>

          <button
            onClick={submit}
            disabled={saving}
            className={`w-full text-xs font-bold px-3 sm:px-4 py-2.5 rounded-lg ${saving
              ? "bg-blue-300 text-white cursor-not-allowed"
              : "bg-blue-600 text-white"
              }`}
          >
            {saving ? "Submitting..." : "Submit Evaluation"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ============================================================
   AWARD / REPORTS / USERS
   ============================================================ */
